<template>
  <footer class="bg-gray-900 text-white pt-20 pb-10">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        <div>
          <a href="#" class="text-3xl font-bold font-display text-amber-500">西明食品</a>
          <p class="text-gray-400 mt-6 mb-8 max-w-md">
            宁夏西明食品有限公司，专业从事食用油脂研发、生产和销售，为食品加工行业提供优质原料。
          </p>
          <div class="flex gap-4">
            <a href="#" class="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-amber-500 hover:text-white transition-all duration-300">
              <Phone :size="18" />
            </a>
            <a href="#" class="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-amber-500 hover:text-white transition-all duration-300">
              <Mail :size="18" />
            </a>
            <a href="#" class="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-amber-500 hover:text-white transition-all duration-300">
              <MapPin :size="18" />
            </a>
          </div>
        </div>
        
        <div>
          <h4 class="text-lg font-semibold mb-6">产品中心</h4>
          <ul class="space-y-4">
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">精炼牛油</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">浓香鸡油</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">浓香牛油</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">原味鸡油</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">原味牛油</a></li>
          </ul>
        </div>
        
        <div>
          <h4 class="text-lg font-semibold mb-6">关于我们</h4>
          <ul class="space-y-4">
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">公司简介</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">企业实力</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">资质认证</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">新闻动态</a></li>
            <li><a href="#" class="text-gray-400 hover:text-amber-400 transition-colors">联系我们</a></li>
          </ul>
        </div>
        
        <div>
          <h4 class="text-lg font-semibold mb-6">联系方式</h4>
          <ul class="space-y-4">
            <li class="flex items-start gap-3">
              <MapPin :size="18" class="text-amber-500 mt-1 shrink-0" />
              <span class="text-gray-400">宁夏回族自治区西吉县吉强镇闽宁大道西吉工业园区食品园8号</span>
            </li>
            <li class="flex items-center gap-3">
              <Phone :size="18" class="text-amber-500 shrink-0" />
              <span class="text-gray-400">13693620799</span>
            </li>
            <li class="flex items-center gap-3">
              <Mail :size="18" class="text-amber-500 shrink-0" />
              <span class="text-gray-400">sales@ximingeco.com</span>
            </li>
            <li class="flex items-center gap-3">
              <Clock :size="18" class="text-amber-500 shrink-0" />
              <span class="text-gray-400">周一至周六 8:00-18:00</span>
            </li>
          </ul>
        </div>
      </div>
      
      <div class="border-t border-white/10 pt-10">
        <div class="flex flex-col md:flex-row justify-between items-center gap-6">
          <p class="text-gray-400 text-sm">
            © 2026 宁夏西明食品有限公司. 保留所有权利。<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="hover:text-amber-500 transition-colors">宁ICP备2026001693号</a>
          </p>
          <div class="flex flex-wrap justify-center gap-8">
            <a href="#" class="text-gray-400 hover:text-white text-sm transition-colors">隐私政策</a>
            <a href="#" class="text-gray-400 hover:text-white text-sm transition-colors">服务条款</a>
            <a href="#" class="text-gray-400 hover:text-white text-sm transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { Phone, Mail, MapPin, Clock } from 'lucide-vue-next'
</script>
